import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./lessonPageTour.css";

/**
 * Tour cho modal Thêm bài học (layout 2 cột giống Thêm tài liệu).
 */
export function startLessonCreateTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Cột trái nhập liệu theo 3 nhóm; cột phải xem kết quả khởi tạo theo thời gian thực.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="lesson-create-header"]',
      title: "Header form",
      description:
        "Tiêu đề form, chip tiến độ và nút hướng dẫn nhanh.",
      side: "bottom",
    },
    {
      selector: '[data-tour="lesson-create-linking"]',
      title: "1. Liên kết khóa học",
      description: "Chọn Môn học trước, rồi Khóa học thuộc môn đó.",
      side: "right",
    },
    {
      selector: '[data-tour="lesson-create-content"]',
      title: "2. Nội dung bài học",
      description: "Nhập thứ tự (tuỳ chọn), tên bài và mô tả.",
      side: "right",
    },
    {
      selector: '[data-tour="lesson-create-documents"]',
      title: "3. Tài liệu liên quan",
      description:
        "Tìm và chọn một hoặc nhiều tài liệu gắn với bài học.",
      side: "right",
    },
    {
      selector: '[data-tour="lesson-create-preview"]',
      title: "Xem trước",
      description:
        "Cột phải tóm tắt môn, khóa, tên bài và số tài liệu đã chọn.",
      side: "left",
    },
    {
      selector: '[data-tour="lesson-create-actions"]',
      title: "Lưu dữ liệu",
      description: "Bấm Lưu bài học để tạo hoặc Hủy bỏ để thoát.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert(
      "Không tìm thấy vùng để chạy hướng dẫn. Hãy mở form rồi thử lại."
    );
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "lesson-page-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
